export enum SessionStore {
  candidate = 'candidate',
  tcPlusAuthStream = 'tcPlusAuthStream',
  candidateDeadlineDate = 'candidateDeadlineDate',
  currentWorkflowItem = 'currentWorkflowItem',
  dpnAccepted = 'dpnAccepted',
  dpnData = 'dpnData',
  applicationFormSubmitted = 'applicationFormSubmitted',
  applicationFormData = 'applicationFormData',
  dummyCandidate = 'dummyCandidate',
  endPageConfig = 'endPageConfig',
  isBrowserSupported = 'isBrowserSupported',
  isSHLAppEnabled = 'isSHLAppEnabled',
  proceedToBrowser = 'proceedToBrowser',
  isIntegrated = 'isIntegrated',
  isTaskInitialized = 'isTaskInitialized',
  isVideoFeedbackGenerationRequested = 'isVideoFeedbackGenerationRequested',
  launchconfig = 'launchconfig',
  launchurl = 'launchurl',
  loggedoutuser = 'loggedoutuser',
  logoutDueToInactivity = 'logoutDueToInactivity',
  schedulableAssessments = 'schedulableAssessments',
  sessionLogoutTimer = 'sessionLogoutTimer',
  sessionWarningTimer = 'sessionWarningTimer',
  template = 'template',
  userSessionActive = 'userSessionActive',
  videoFeedback = 'videoFeedback',
  workflowSession = 'workflowSession',
  allowRedirectToTasklist = 'allowRedirectToTasklist',
  isAppPrompt = 'isAppPrompt',
  isEntryExhausted = 'isEntryExhausted',
  surveyTriggerCodes = 'surveyTriggerCodes',
  companySettings = 'companySettings',
  formStatus = 'formStatus',
  basicTaskList = 'basicTaskList',
  companyLogoUrl = 'companyLogoUrl',
  tpurlc = 'tpnurlc',
  tpurlnc = 'tpnurlnc',
  selectedAccountId = 'selectedAccountId',
  mfsLanguages = 'mfsLanguages',
}

export enum LocalStorageKeys {
  acceptProctoring = 'acceptProctoring',
  cameraPermission = 'cameraPermission',
}

export const ACCEPT = 'Accept';
export const ALLOWED = 'Allowed';
export const BLOCKED = 'Blocked';
